<mat-icon matTooltip="{{isTask ? 'Delete Task' : 'Delete job'}}" (click)="deleteJob($event)"
    class="button-icon">delete</mat-icon>